import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';
import { faStar } from '@fortawesome/pro-light-svg-icons';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TrueImpactStarProps {
  count?: number;
  starColor?: keyof typeof COLORS;
  backgroundColor?: keyof typeof COLORS;
  className?: string;
  filled?: boolean;
}

const StyledDiv = styled.div<{ backgroundColor: keyof typeof COLORS }>`
  display: flex;
  width: 24px;
  height: 24px;
  border-radius: 32px;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => COLORS[backgroundColor]};
  svg {
    width: 16px;
    height: 16px;
    margin-top: -1px;
  }
`;

const TrueImpactStarRender: React.FC<{
  starColor: keyof typeof COLORS;
  backgroundColor: keyof typeof COLORS;
  className?: string;
  filled?: boolean;
}> = ({ starColor, backgroundColor, className, filled }) => {
  return (
    <StyledDiv backgroundColor={backgroundColor} className={className}>
      <FontAwesomeIcon
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon={filled ? (faSolidStar as any) : faStar}
        color={COLORS[starColor]}
      />
    </StyledDiv>
  );
};

const TrueImpactStar: React.FC<TrueImpactStarProps> = ({
  count = 1,
  starColor = 'success',
  backgroundColor = 'successBackground',
  className,
  filled = false,
}) => {
  const stars: React.ReactNode[] = [];
  for (let i = 0; i < count; i++) {
    stars.push(
      <TrueImpactStarRender
        key={i}
        starColor={starColor}
        backgroundColor={backgroundColor}
        className={className}
        filled={filled}
      />,
    );
  }
  return <>{stars}</>;
};

export default TrueImpactStar;
